module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Sum of coindays destroyed in period (log scale).\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-cdd"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc70e7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/cdd.vue
// module id = 536
// module chunks = 1